// Curated commercial HVAC model catalog — the units a residential /
// light-commercial shop in the Northeast actually sees on nameplates.
// Sourced from AHRI directory + manufacturer spec sheets (2024).
// Techs type "carr" → autocomplete narrows to Carrier options, picking
// one auto-fills tonnage, SEER, and stage — no more squinting at a
// dusty nameplate.
//
// Format: { model, brand, kind, tons, seer, stage, refrigerant, notes }

export const HVAC_UNITS = [
  // ── Carrier ─────────────────────────────────────────────
  { model: "25HCB6",  brand: "Carrier", kind: "central_ac", tons: 3,   seer: 16, stage: "single",  refrigerant: "R-410A", notes: "Comfort 16 series" },
  { model: "24ACC6",  brand: "Carrier", kind: "central_ac", tons: 2.5, seer: 16, stage: "single",  refrigerant: "R-410A", notes: "Comfort" },
  { model: "24ANB7",  brand: "Carrier", kind: "central_ac", tons: 3,   seer: 17, stage: "2-stage", refrigerant: "R-410A", notes: "Performance 17" },
  { model: "25VNA0",  brand: "Carrier", kind: "heat_pump",  tons: 3,   seer: 20, stage: "variable",refrigerant: "R-410A", notes: "Infinity 20 Greenspeed" },
  { model: "58STA",   brand: "Carrier", kind: "furnace",    tons: null,seer: null,stage: "single", refrigerant: null,     notes: "80% AFUE gas furnace" },
  { model: "59TN6",   brand: "Carrier", kind: "furnace",    tons: null,seer: null,stage: "2-stage",refrigerant: null,     notes: "Infinity 96 gas furnace" },

  // ── Trane ───────────────────────────────────────────────
  { model: "4TTR4036",brand: "Trane",   kind: "central_ac", tons: 3,   seer: 14, stage: "single",  refrigerant: "R-410A", notes: "XR14" },
  { model: "4TTR6036",brand: "Trane",   kind: "central_ac", tons: 3,   seer: 17, stage: "2-stage", refrigerant: "R-410A", notes: "XR17" },
  { model: "4TWR7036",brand: "Trane",   kind: "heat_pump",  tons: 3,   seer: 18, stage: "2-stage", refrigerant: "R-410A", notes: "XV18" },
  { model: "S9V2",    brand: "Trane",   kind: "furnace",    tons: null,seer: null,stage: "variable",refrigerant: null,    notes: "97% AFUE modulating" },

  // ── Lennox ──────────────────────────────────────────────
  { model: "13ACX",   brand: "Lennox",  kind: "central_ac", tons: 3,   seer: 13, stage: "single",  refrigerant: "R-410A", notes: "Merit 13 SEER" },
  { model: "EL16XC1", brand: "Lennox",  kind: "heat_pump",  tons: 3,   seer: 17, stage: "single",  refrigerant: "R-410A", notes: "Elite 17" },
  { model: "XC25",    brand: "Lennox",  kind: "central_ac", tons: 3,   seer: 26, stage: "variable",refrigerant: "R-410A", notes: "Signature 26 SEER" },
  { model: "SL280V",  brand: "Lennox",  kind: "furnace",    tons: null,seer: null,stage: "variable",refrigerant: null,    notes: "Signature 80% AFUE" },

  // ── York ────────────────────────────────────────────────
  { model: "YCJF48",  brand: "York",    kind: "rooftop",    tons: 4,   seer: 14, stage: "single",  refrigerant: "R-410A", notes: "Light-commercial rooftop pkg" },
  { model: "YCJF36",  brand: "York",    kind: "central_ac", tons: 3,   seer: 14, stage: "single",  refrigerant: "R-410A", notes: "Latitude 14" },
  { model: "YXV",     brand: "York",    kind: "central_ac", tons: 3,   seer: 20, stage: "variable",refrigerant: "R-410A", notes: "Affinity Variable" },

  // ── Rheem / Ruud ────────────────────────────────────────
  { model: "RA1436",  brand: "Rheem",   kind: "central_ac", tons: 3,   seer: 14, stage: "single",  refrigerant: "R-410A", notes: "Classic 14" },
  { model: "RA1748",  brand: "Rheem",   kind: "central_ac", tons: 4,   seer: 17, stage: "2-stage", refrigerant: "R-410A", notes: "Prestige RA17" },
  { model: "R92T",    brand: "Rheem",   kind: "furnace",    tons: null,seer: null,stage: "single", refrigerant: null,     notes: "92% AFUE gas" },

  // ── Goodman / Amana / Daikin ────────────────────────────
  { model: "GSX140361", brand: "Goodman", kind: "central_ac", tons: 3, seer: 14, stage: "single", refrigerant: "R-410A", notes: "GSX 14 (Amana AZM)" },
  { model: "GSXC18",  brand: "Goodman", kind: "central_ac", tons: 3,   seer: 18, stage: "2-stage", refrigerant: "R-410A", notes: "GSXC18" },
  { model: "DZ18VC",  brand: "Daikin",  kind: "heat_pump",  tons: 3,   seer: 18, stage: "variable",refrigerant: "R-410A", notes: "Fit series inverter" },

  // ── Ductless mini-split (huge in Philly rowhouse stock) ─
  { model: "MSZ-FS12NA", brand: "Mitsubishi", kind: "mini_split", tons: 1,   seer: 23, stage: "variable", refrigerant: "R-410A", notes: "Wall unit 12k" },
  { model: "MXZ-3C24NAHZ2", brand: "Mitsubishi", kind: "mini_split", tons: 2, seer: 20, stage: "variable", refrigerant: "R-410A", notes: "Hyper-Heat multi-zone" },
  { model: "MUZ-GL15NA", brand: "Mitsubishi", kind: "mini_split", tons: 1.25, seer: 22, stage: "variable", refrigerant: "R-410A", notes: "GL series wall" },
  { model: "MUZ-FS09NA", brand: "Mitsubishi", kind: "mini_split", tons: 0.75, seer: 33, stage: "variable", refrigerant: "R-410A", notes: "FS 9k hyper-heat" },
  { model: "AOU12RLFC", brand: "Fujitsu",   kind: "mini_split", tons: 1,   seer: 26, stage: "variable", refrigerant: "R-410A", notes: "Halcyon" },
];

export function matchHvacUnits(q, limit = 8) {
  const needle = (q || "").trim().toLowerCase();
  if (!needle) return HVAC_UNITS.slice(0, limit);
  return HVAC_UNITS.filter((u) =>
    u.model.toLowerCase().includes(needle) ||
    u.brand.toLowerCase().includes(needle) ||
    u.kind.replace("_", " ").includes(needle) ||
    (u.notes || "").toLowerCase().includes(needle)
  ).slice(0, limit);
}


// ─── HVAC Common Fault Library ───────────────────────────
// Techs pick a symptom → get the deterministic checklist + typical part
// specs the shop already knows. ZERO LLM calls. Only when the checklist
// doesn't nail it do we escalate to the paid AI diagnose. Keeps the bill
// tiny — 80% of service-call symptoms live in this table.
export const HVAC_COMMON_FIXES = [
  {
    id: "not_cooling_condenser_running",
    label: "Blowing warm — condenser running",
    likely: [
      "Low refrigerant charge (needs recovery + leak search)",
      "Dirty condenser coil (>50% blockage kills capacity)",
      "Stuck / oversized indoor filter (return static too high)",
      "TXV or piston restricted",
    ],
    parts_typical: "Manifold gauges · leak detector · coil cleaner · new filter",
    diagnostic_steps: [
      "Check indoor filter first — replace if grey/black",
      "Wash outdoor condenser coil (power OFF)",
      "Hook up gauges → read superheat + subcool",
      "If low, EPA-608 recovery + electronic leak search",
    ],
  },
  {
    id: "condenser_no_start",
    label: "Condenser fan not spinning",
    likely: [
      "Failed run capacitor (most common — spin test with insulated stick)",
      "Failed contactor (pitted / stuck)",
      "Motor bearings seized",
      "Loose 24V control wire from thermostat",
    ],
    parts_typical: "Dual-run cap 45/5 or 40/5 µF 440V · 30A 2-pole contactor · fan motor 1/6 HP",
    diagnostic_steps: [
      "Verify 240V at compressor terminals (multimeter)",
      "Discharge + test run capacitor (µF meter — replace if <90%)",
      "Manually push fan blade — if it spins & starts, capacitor is dead",
      "Check contactor points — pit + arc = replace",
    ],
  },
  {
    id: "compressor_no_start",
    label: "Compressor hums but won't start",
    likely: [
      "Failed start capacitor (or missing hard-start kit on old scroll)",
      "Locked rotor — compressor internally seized",
      "Low incoming voltage (<210V single-phase)",
    ],
    parts_typical: "Hard-start kit (5-2-1 or SPP6) · start cap 88-108 µF",
    diagnostic_steps: [
      "Measure L1-L2 at contactor with unit running — must be ≥210V",
      "Test start cap — replace if drifted",
      "Install hard-start kit if compressor is >5 yrs old",
      "If locked rotor: compressor replacement or condensing-unit swap",
    ],
  },
  {
    id: "furnace_short_cycle",
    label: "Furnace short-cycling",
    likely: [
      "Dirty flame sensor (clean with fine steel wool)",
      "Clogged filter — high-limit trips",
      "Cracked heat exchanger (safety — shut down)",
      "Failing pressure switch (bad tube or blocked flue)",
    ],
    parts_typical: "Flame sensor · pressure switch · IFC board · high-limit switch",
    diagnostic_steps: [
      "Pull + clean flame sensor first (2-min job, fixes 40%)",
      "Replace air filter, verify blower amp draw at rated FLA",
      "Check inducer flue for blockage / debris",
      "CO test — if HX cracked, red-tag immediately",
    ],
  },
  {
    id: "furnace_no_heat",
    label: "Furnace no heat / no ignition",
    likely: [
      "Bad igniter (hot-surface or spark)",
      "No gas at valve (LP tank / gas cock / regulator)",
      "IFC control board LED code (read blink pattern)",
      "Pressure switch stuck open (tube kinked or wet)",
    ],
    parts_typical: "Hot-surface igniter (silicon nitride) · IFC board · gas valve",
    diagnostic_steps: [
      "Read IFC LED blink code — the board tells you the fault",
      "Check for 120V at igniter during call-for-heat",
      "Verify inlet gas pressure 7 in.w.c. (nat gas)",
      "Ohm the igniter — 40-90 ohms good, open = replace",
    ],
  },
  {
    id: "heat_pump_freezing",
    label: "Heat pump outdoor coil freezing over",
    likely: [
      "Defrost board not initiating cycle",
      "Reversing valve stuck / bleeding",
      "Low refrigerant charge",
      "Outdoor fan not running in reverse mode",
    ],
    parts_typical: "Defrost control board · reversing valve solenoid · outdoor sensor",
    diagnostic_steps: [
      "Force defrost via test pins on board",
      "Check outdoor coil / ambient sensors (ohm at 25kΩ @ 77°F typical)",
      "Verify reversing valve energizes on cool call",
    ],
  },
  {
    id: "airflow_weak",
    label: "Weak airflow at registers",
    likely: [
      "Blower wheel packed with lint",
      "ECM module failed",
      "Duct restriction / crushed return",
      "Static pressure too high (over-registered evaporator)",
    ],
    parts_typical: "ECM control module · direct-drive blower motor · new filter",
    diagnostic_steps: [
      "Pull blower — clean squirrel-cage wheel (huge airflow gain)",
      "Take total external static across return + supply",
      "Verify motor amp draw at nameplate",
    ],
  },
  {
    id: "condensate_leak",
    label: "Water leaking from indoor unit",
    likely: [
      "Clogged condensate line (P-trap growing biofilm)",
      "Failed safety float switch",
      "Frozen evaporator coil thawing (fix root cause first)",
      "Cracked drain pan",
    ],
    parts_typical: "Condensate pump · float switch · trap primer tablets · shop-vac",
    diagnostic_steps: [
      "Vacuum condensate line from outside termination",
      "Flush pan with 1:1 vinegar or condensate tabs",
      "Verify float switch continuity — replace if stuck",
    ],
  },
];
